module.exports = __webpack_public_path__ + "static/media/blobOne.c2edf81c.svg";